import api from '../api/newsletter'
import { fetchNewsletter } from './api'
import { setListData } from './meta'

export const actionTypes = {
	RECEIVE_NEWSLETTER: 'newsletter/RECEIVE_NEWSLETTER',
  RECEIVE_SECTOR_NEWSLETTER: 'newsletter/RECEIVE_SECTOR_NEWSLETTER',
  RECEIVE_DATES: 'newsletter/RECEIVE_DATES',
  SET_YEAR: 'newsletter/SET_YEAR',
  SET_MONTH: 'newsletter/SET_MONTH',
	SET_SECTOR: 'newsletter/SET_SECTOR',
  RECEIVE_SECTORS: 'newsletter/RECEIVE_SECTORS',
  RECEIVE_FILTERED_NEWLETTERS: 'newsletter/RECEIVE_FILTERED_NEWLETTERS',
  RECEIVE_NOTE_DETAIL: 'newsletter/RECEIVE_NOTE_DETAIL',
  SAVE_NEWSLETTER_DETAIL: 'newsletter/SAVE_NEWSLETTER_DETAIL',
  RECEIVE_NOTES: 'newsletter/RECEIVE_NOTES',
  LOADING_NEWSLETTERS: 'newsletter/LOADING_NEWSLETTERS',
  ERROR: 'newsletter/ERROR'
}

export const loadNewsletters = (pl, p) => {
	return (dispatch) => {
    dispatch(loadingResults())
    api.fetchNewsletterList(pl, p)
      .then((data) => {
        dispatch(receiveNewsletter(data))
      })
  }
}

export const loadNewslettersByPagination = (pl, p) => {
  return (dispatch) => {
    api.fetchNewsletterList(pl, p)
      .then((data) => {
        dispatch(receiveNewsletter(data))
      })
  }
}

export const loadNewsletterBySector = (id) => {
  return(dispatch) => {
    api.fetchNewsletterBySector(id)
      .then((data) => dispatch(receiveSectorNewsletter(data)))
  }
}

export const setSector = (value='', id) =>
	(dispatch) => {
		dispatch(changeSector(value))
		dispatch(loadNewsletterBySector(id))
	}

export const changeSector = value => {
	return { type: actionTypes.SET_SECTOR, value }
}

function loadingResults() {
  return {
    type: actionTypes.LOADING_NEWSLETTERS
  }
}

function receiveSectorNewsletter(APIdata) {
  return {
    type: actionTypes.RECEIVE_SECTOR_NEWSLETTER,
    data: APIdata.data
  }
}

export const loadDates = () => {
  return(dispatch) => {
    api.fetchNewsletterDates()
      .then((data) => dispatch(receiveDates(data)))
  }
}

function receiveDates(APIdata) {
  return {
    type: actionTypes.RECEIVE_DATES,
    data: APIdata
  }
}

export const setYears = (value='') => {
  return(dispatch) => {
    dispatch(changeYear(value))
    dispatch(fetchNewsletter())
  }
}

export const changeYear = (value) => {
  return {
    type: actionTypes.SET_YEAR,
    value: value
  }
}

export const setMonth = (value='') =>
	(dispatch) => {
    dispatch(changeMonth(value))
    dispatch(fetchNewsletter())
	}

export const changeMonth = (value) => {
  return {
    type: actionTypes.SET_MONTH,
    value: value
  }
}

export const searchNewsletterByWords = (value) => {
  return(dispatch) => {
    api.fetchNewsletterByWords(value)
      .then((data) => {
        dispatch(receiveNewsletter(data))
      })
  }
}

function receiveNewsletter(APIdata) {
  return {
    type: actionTypes.RECEIVE_NEWSLETTER,
    data: APIdata
  }
}

export const loadSectors = sectors => {
  return(dispatch) => {
    api.fetchNewsletterSectors(sectors)
      .then(data => dispatch(receiveSectors(data)))
  }
}

function receiveSectors(APIdata) {
  return {
    type: actionTypes.RECEIVE_SECTORS,
    data: APIdata
  }
}

export const getNewsletterWithFilter = (m, y) => {
  return (dispatch) => {
    api.fetchFilterNewsletters(m, y)
      .then((data) => {
        dispatch(receiveFilteredNewsletters(data))
      })
      .catch((err) => {
        dispatch(error(err.join('\n')))
      })
  }
}

function receiveFilteredNewsletters(APIdata) {
  return {
    type: actionTypes.RECEIVE_FILTERED_NEWLETTERS,
    data: APIdata
  }
}

function error(APIdataerr) {
  return {
    type: actionTypes.ERROR,
    error: APIdataerr
  }
}

export const loadNoteById = (id) => {
  return(dispatch) => {
    api.fetchNoteById(id)
      .then((data) => dispatch(receiveNoteDetail(data)))
  }
}

function receiveNoteDetail(APIdata) {
  return {
    type: actionTypes.RECEIVE_NOTE_DETAIL,
    data: APIdata
  }
}

export const searchNotesByForm = (value) => {
  return(dispatch) => {
    api.fetchNotesByWords(value)
      .then((data) => {
        dispatch(receiveNotes(data))
        dispatch(setListData(data))
      })
  }
}

function receiveNotes(APIdata) {
  return {
    type: actionTypes.RECEIVE_NOTES,
    data: APIdata.data
  }
}

export const loadNotes = (id) => {
  return(dispatch) => {
    api.fetchNotes(id)
      .then((data) => {
        dispatch(receiveNotes(data))
        dispatch(setListData(data))
      })
    api.fetchNewsletterById(id)
      .then((data) => dispatch(saveNewsletter(data)))
  }
}

export const saveNewsletter = (data) => {
  return {
    type: actionTypes.SAVE_NEWSLETTER_DETAIL,
    data: data
  }
}



// WEBPACK FOOTER //
// ./src/actions/newsletter.js